import React from "react";

function Logo() {
  return (
    <span className="logo text-xl">
      <span className=" text-slate-400">
        <span className="text-blue-600 ">{"<"}</span>
        <span className="">rabah</span>
      </span>
      <span className="text-blue-600 ">tech{"/>"}</span>
    </span>
  );
}

export default Logo;
